import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import { getOneLog, getAllLogs, deleteGameLog } from "../../services/gameLog.services";
import { GeneratePlayerStats } from "./helper";
import "./gamelogdetails.css";
import DownloadFilesOverlay from "../../UserComponents/overlays/DownloadFilesOverlay.js";
import jsPDF from "jspdf";
import domtoimage from "dom-to-image";
import mainImg from '../assets/dashboard.png';

import DeleteOverlay from "../../UserComponents/overlays/DeleteOverlay";
import SuccessOverlay from "../../UserComponents/overlays/SuccessOverlay";

import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import UserSidebar from "../../../components/userSiderbar/userSidebar.jsx";

const GameLogDetails = (props) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [delIsVisible, setDelIsVisible] = useState(false);
  const [delSuccessVisible, setDelSuccessVisible] = useState(false);
  const [activityState, setActivityState] = useState([]);
  const [visible, setVisible] = useState(false);
  const [gameLogVisible, setGameLogVisible] = useState(false);
  const [gameSummaryVisible, setGameSummaryVisible] = useState(false);
  const [playerSummaryVisible, setPlayerSummaryVisible] = useState(false);
  const [downloadFilesVisible, setDownloadFilesVisible] = useState(false);
  const [data, setData] = useState(null);
  const [playedIngameFilteredPlayers, setPlayedIngameFilteredPlayers] =
    useState(null);
  const [isOverlayVisible, setOverlayVisible] = useState(false);
  const [activeView, setActiveView] = useState(null);

  const [isNoneStatsA, setIsNoneStatsA] = useState(false);
  const [isNoneStatsB, setIsNoneStatsB] = useState(false);

  const [playerStats, setPlayerStats] = useState({});
  const [topPerformers, setTopPerformers] = useState({});
  const [seasonStatsLoading, setSeasonStatsLoading] = useState(false);
  const [gameData, setGameData] = useState([]);
  const [opponentShotOGTotal, setOpponentShotOGTotal] = useState(0);

  const user = useSelector((state) => state.auth.user);
  const operatorTeam = useSelector((state) => state.team.selectedTeam);
  // const general = useSelector((state) => state.clockStatsOnlyReducer.general);
  const history = useHistory();
  const { logId } = useParams();

  const A = data?.teamA;
  const A1 = A?.qtrStats ? A.qtrStats?.quarter1 : A?.periodStats?.period1;
  const A2 = A?.qtrStats ? A.qtrStats?.quarter2 : A?.periodStats?.period2;
  const A3 = A?.qtrStats ? A.qtrStats?.quarter3 : A?.periodStats?.period3;
  const A4 = A?.qtrStats ? A.qtrStats?.quarter4 : A?.periodStats?.period4;

  const B = data?.teamB;
  const B1 = B?.qtrStats ? B.qtrStats?.quarter1 : B?.periodStats?.period1;
  const B2 = B?.qtrStats ? B.qtrStats?.quarter2 : B?.periodStats?.period2;
  const B3 = B?.qtrStats ? B.qtrStats?.quarter3 : B?.periodStats?.period3;
  const B4 = B?.qtrStats ? B.qtrStats?.quarter4 : B?.periodStats?.period4;

  let { teamAplayerStats, teamBplayerStats } = GeneratePlayerStats(data);

  const sections = {
    Scoring: ["Goals", "ASST", "TS", "SOG"],
    Fielding: ["GB", "CT", "TO", "TA", "INT", "UE"],
    "Face Offs": ["FA", "FW", "FV", "FOGB"],
    "Goal Tending": ["Min", "SAVES", "SC", "SNC", "GA", "WON", "LOST", "TIE"],
  };

  const statMappings = {
    Goals: "goals",
    ASST: "assists",
    TS: "shotAttempts",
    SOG: "shotOG",
    GB: "groundBall",
    CT: "causedTurnover",
    TO: "turnOver",
    TA: "takeAway",
    INT: "interceptions",
    UE: "unforcedErrors",
    FA: "faceoffsAttempts",
    FW: "faceoffsWon",
    FV: "faceoffsViolation",
    FOGB: "faceoffGB",
    Min: "goaliePlayedTime",
    SAVES: "saves",
    SC: "shotsConceded",
    SNC: "shotsOnNet",
    GA: "goalsAgainst",
    WON: "won",
    LOST: "lost",
    TIE: "tie",
  };

  const sumStat = (teamStats, statType) =>
    teamStats.reduce((total, player) => total + (player[statType] || 0), 0);

  const renderTable = (teamStats, sectionTitle, statTypes) => {
    const sortedTeamStats = [...teamStats].sort(
      (a, b) => (a.jersey || 0) - (b.jersey || 0)
    );

    const convertSecondsToTime = (totalSeconds) => {
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    let displayIdx = 0; // Track displayed row index separately

    return (
      <table key={sectionTitle} className="player-stats-table">
        <thead>
          <tr>
            <th>Jersey #</th>
            <th>Player</th>
            {statTypes.map((stat) => (
              <th key={stat}>{stat}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedTeamStats.map((player, idx) => {
            const hasStats = statTypes.some(
              (stat) => player[statMappings[stat]] !== undefined
            );
            if (
              statTypes.includes("Min") &&
              statMappings["Min"] in player &&
              (!player[statMappings["Min"]] || player[statMappings["Min"]] === 0)
            ) {
              return null;
            }
            if (!hasStats) return null;

            const rowStyle =
              displayIdx % 2 === 0
                ? { backgroundColor: "#e6e4e4" }
                : { backgroundColor: "#ffffff" };
            displayIdx++;

            return (
              <tr key={player.jersey || idx} style={rowStyle}>
                <td>{player.jersey || ""}</td>
                <td>{player.player || ""}</td>
                {statTypes.map((stat) => (
                  <td key={stat}>
                    {stat === "Min"
                      ? convertSecondsToTime(player[statMappings[stat]]) || "0:00"
                      : player[statMappings[stat]] || 0}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>

        {/* Team total row */}
        <tfoot className="team-total">
          <tr className="totals-all">
            <td style={{ border: "none" }}></td>
            <td style={{ border: "none", color: "rgb(73, 141, 218)" }}>
              <strong>Team Totals: </strong>
            </td>
            {statTypes.map((stat) => (
              <td key={`total` - `${stat}`}>
                <strong key={stat}>
                  {stat === "Min"
                    ? convertSecondsToTime(sumStat(teamStats, statMappings[stat])) || "0:00"
                    : sumStat(teamStats, statMappings[stat])}
                </strong>
              </td>
            ))}
          </tr>
        </tfoot>
      </table>
    );
  };

  const renderTableWithTotals = (teamStats) => {
    const sortedTeamStats = [...teamStats].sort(
      (a, b) => (a.jersey || 0) - (b.jersey || 0)
    );
    const getTotalsForAllSections = (teamStats, sections) => {
      const totalStats = {};

      Object.keys(sections).forEach((section) => {
        sections[section].forEach((stat) => {
          totalStats[stat] = teamStats.reduce(
            (total, player) => total + (player[statMappings[stat]] || 0),
            0
          );
        });
      });

      return totalStats;
    };

    const totals = getTotalsForAllSections(teamStats, sections);

    return (
      <table className="player-stats-table-combined">
        <thead>
          <tr>
            <th rowSpan="2">#</th>
            <th rowSpan="2">Name</th>
            {/* <th rowSpan="2">+/-</th> */}
            <th
              colSpan="4"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Scoring
            </th>
            <th
              colSpan="6"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Fielding
            </th>
            <th
              colSpan="4"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Face Offs
            </th>
            <th
              colSpan="8"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Goal Tending
            </th>
          </tr>
          <tr>
            {/* Scoring */}
            <th>Goals</th>
            <th>ASST</th>
            <th>TS</th>
            <th>SOG</th>

            {/* Fielding */}
            <th>GB</th>
            <th>CT</th>
            <th>TO</th>
            <th>TA</th>
            <th>INT</th>
            <th>UE</th>

            {/* Face Offs */}
            <th>FA</th>
            <th>FW</th>
            <th>FV</th>
            <th>FOGB</th>

            {/* Goal Tending */}
            <th>Min</th>
            <th>SAVES</th>
            <th>SC</th>
            <th>SNC</th>
            <th>GA</th>
            <th>WON</th>
            <th>LOST</th>
            <th>TIE</th>
          </tr>
        </thead>
        <tbody>
          {sortedTeamStats
            .filter((player) => player.jersey && player.player) // Filter out players with no jersey or name
            .map((player, idx) => (
              <tr key={idx}>
                <td>{player.jersey || ""}</td>
                <td>{player.player || ""}</td>

                {/* Scoring */}
                <td>{player.goals || 0}</td>
                <td>{player.assists || 0}</td>
                <td>{player.shotAttempts || 0}</td>
                <td>{player.shotOG || 0}</td>

                {/* Fielding */}
                <td>{player.groundBall || 0}</td>
                <td>{player.causedTurnover || 0}</td>
                <td>{player.turnOver || 0}</td>
                <td>{player.takeAway || 0}</td>
                <td>{player.interceptions || 0}</td>
                <td>{player.unforcedErrors || 0}</td>

                {/* Face Offs */}
                <td>{player.faceoffsAttempts || 0}</td>
                <td>{player.faceoffsWon || 0}</td>
                <td>{player.faceoffsViolation || 0}</td>
                <td>{player.faceoffGB || 0}</td>

                {/* Goal Tending */}
                <td>{player.minutesPlayed || 0}</td>
                <td>{player.saves || 0}</td>
                <td>{player.shotsConceded || 0}</td>
                <td>{player.shotsOnNet || 0}</td>
                <td>{player.goalsAgainst || 0}</td>
                <td>{player.won || 0}</td>
                <td>{player.lost || 0}</td>
                <td>{player.tie || 0}</td>
              </tr>
            ))}

          <tr>
            <th
              colSpan="6"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Scoring
            </th>
            <th
              colSpan="6"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Fielding
            </th>
            <th
              colSpan="4"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Face Offs
            </th>
            <th
              colSpan="8"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Goal Tending
            </th>
          </tr>
          <tr>
            <td colSpan="2" className="totals-row">
              <strong>Team Totals</strong>
            </td>
            {/* colSpan="3" */}
            {/* Scoring Totals */}

            <td>
              <strong>{totals.Goals}</strong>
            </td>
            <td>
              <strong>{totals.ASST}</strong>
            </td>
            <td>
              <strong>{totals.TS}</strong>
            </td>
            <td>
              <strong>{totals.SOG}</strong>
            </td>

            {/* Fielding Totals */}
            <td>
              <strong>{totals.GB}</strong>
            </td>
            <td>
              <strong>{totals.CT}</strong>
            </td>
            <td>
              <strong>{totals.TO}</strong>
            </td>
            <td>
              <strong>{totals.TA}</strong>
            </td>
            <td>
              <strong>{totals.INT}</strong>
            </td>
            <td>
              <strong>{totals.UE}</strong>
            </td>

            {/* Face Offs Totals */}
            <td>
              <strong>{totals.FA}</strong>
            </td>
            <td>
              <strong>{totals.FW}</strong>
            </td>
            <td>
              <strong>{totals.FV}</strong>
            </td>
            <td>
              <strong>{totals.FOGB}</strong>
            </td>

            {/* Goal Tending Totals */}
            <td>
              <strong>{totals.Min}</strong>
            </td>
            <td>
              <strong>{totals.SAVES}</strong>
            </td>
            <td>
              <strong>{totals.SC}</strong>
            </td>
            <td>
              <strong>{totals.SNC}</strong>
            </td>
            <td>
              <strong>{totals.GA}</strong>
            </td>
            <td>
              <strong>{totals.WON}</strong>
            </td>
            <td>
              <strong>{totals.LOST}</strong>
            </td>
            <td>
              <strong>{totals.TIE}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  useEffect(() => {
    const fetchAllLogs = async () => {
      try {
        const response = await getAllLogs(user?.token);
        // console.log("✅ All Logs Response:", response.data);

        // If it's an array of logs, you can peek into the first one
        // console.log("First log full detail:", response.data[0]);
        // console.log("Keys of first log:", Object.keys(response.data[0]));

      } catch (error) {
        console.error("❌ Error fetching all logs:", error.message);
      }
    };

    if (user?.token) {
      fetchAllLogs();
    }
  }, [user?.token]);


  useEffect(() => {
    console.log("GameLogDetails rendered with ID:", logId);
  }, [logId]);

  useEffect(() => {
    const fetchGameLogDetails = async () => {
      try {
        setLoading(true);
        const response = await getOneLog(logId, user?.token);
        console.log("API Response Data:", response.data); // Log the data
        setData(response.data);
      } catch (error) {
        console.error("ERROR in getOneLog:", error.message);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchGameLogDetails();
  }, [logId, user?.token]);

  const toggleFileDownload = () => {
    setDownloadFilesVisible(!downloadFilesVisible);
  };

  const downloadActivityLog = async () => {
    const dateX = moment(data.createdAt)
      .format("MM-D-YYYY, h:mm:ss a")
      .slice(0, 10);

    if (data) {
      try {
        // Step 1: Create a UUID-to-Sequence Map
        const uuidSequenceMap = {};
        let sequenceNumber = 1;

        const filteredActivityLog = data.activityLog.filter(
          (v) => v?.statement !== "Played In Game"
        );

        filteredActivityLog.forEach((obj) => {
          if (!uuidSequenceMap[obj.uuid]) {
            uuidSequenceMap[obj.uuid] = sequenceNumber++;
          }
        });

        const activityLogRows = filteredActivityLog.map((obj, index) => [
          obj.buttonPressed || "",
          uuidSequenceMap[obj.uuid], // Include UUID here
          index + 1,
          obj.team || "-",
          obj.jersey || "-1",
          obj.player || "Team Stat",
          obj.quarter || obj.period || "",
          obj.clockTime || "",
          obj.code || "",
          obj.statement || "",
          obj.rating || "",
          obj.addDesc || "",
          obj.cat || "",
          obj.pType || "",
          obj.pTime || "",
          obj.goaliePlayedTime || "",
        ]);

        const playedIngameRows = playedIngameFilteredPlayers.map(
          (val, index) => [
            "",
            "",
            activityLogRows.length + index + 1, // Adjusting the index for playedIngameFilteredPlayers
            data.teamA.teamName || "",
            val.jersey || "",
            (val.playerName || "").split(" ").pop(),
            "E.O.G",
            "",
            "GP",
            "Played In Game",
            "",
            "",
            "Fielding",
          ]
        );

        const val = [
          [
            "Button Pressed",
            "Trans#", // Add UUID header
            "Seq#",
            "TEAM",
            "JER#",
            "NAME",
            "Qtr",
            "TIME",
            "CODE",
            "DESC",
            "Rating",
            "Additional Description",
            "CAT",
            "P-Type",
            "P-Time",
            "Goalie Time Played"
          ],
          ...activityLogRows,
          ...playedIngameRows,
        ];

        // Construct CSV string
        const headerString = "\n";
        const rowString = val.map((row) => row.join(",")).join("\n");

        const csvString = `${headerString}${rowString}`;

        // Create a Blob from the CSV string
        const blob = new Blob([csvString], { type: "text/csv" });

        // Create a link element to trigger the download
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = `${data.teamA.teamName}-gameLog(${dateX})-(${data.teamB.teamName}).csv`;

        // Append the link to the body and simulate a click to download
        document.body.appendChild(link);
        link.click();

        // Clean up
        URL.revokeObjectURL(url);
        document.body.removeChild(link);

        console.log("<<==  Downloaded ACTIVITY LOG successfully ==>>>");
      } catch (e) {
        console.error("Error in downloading file", e);
      }
    }
  };

  const downloadMaxPrepTxt = async () => {
    let { teamAplayerStats } = GeneratePlayerStats(data);
    const dateX = moment(data.createdAt)
      .format("MM-D-YYYY, h:mm:ss a")
      .slice(0, 10);

    const convertSecondsToTime = (totalSeconds) => {
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      // Round up if seconds are 30 or more
      return seconds >= 30 ? minutes + 1 : minutes;
    }

    let dataExcludeTM = [];
    teamAplayerStats.map((v) => {
      if (v.jersey !== "-1" && v.player !== undefined) {
        dataExcludeTM.push(v);
      }
    });

    if (data) {
      let dataString =
        "\n" +
        "Jersey|Goals|Assists|TotalShots|ShotsOnGoal|GroundBalls|Turnovers|Takeaways|UnforcedErrors|FaceoffWon|FaceoffAttempts|MinutesPlayed|GoalsAgainst|Saves|ShutOuts|Wins|Losses|Ties|Penalties|PenaltyMinutes|PenaltySeconds\n";

      const data_exclude_TM_string = dataExcludeTM
        .map((val) => {
          if (val.jersey !== "-1") {
            const goaliePlayedTimeFormatted = val.goaliePlayedTime
              ? convertSecondsToTime(val.goaliePlayedTime)
              : "";
            return [
              `${val.jersey || ""}|${val.goals || ""}|${val.assists || ""}|${val.shotAttempts || ""
              }|${val.shotOG || ""}|${val.groundBall || ""}|${val.turnOver || val.faceoffsViolation
                ? (val.turnOver || 0) + (val.faceoffsViolation || 0)
                : ""
              }|${val.takeAway || val.causedTurnover
                ? (val.takeAway || 0) + (val.causedTurnover || 0)
                : ""
              }|${val.unforcedError || ""}|${val.faceoffsWon || ""}|${val.FaceoffAttempts || ""
              }|${goaliePlayedTimeFormatted || ""}||${val.goalsAgainst || ""}|${val.saves || ""}||||||||`,
            ];
          }
        })
        .filter(Boolean)
        .join("\n");

      dataString = dataString + data_exclude_TM_string + "\n";

      const played_in_game_string = playedIngameFilteredPlayers
        .map((val) => {
          if (val.jersey !== "-1") {
            return `${val.jersey}||||||||||||||||||`;
          }
        })
        .filter(Boolean)
        .join("\n");

      dataString = dataString + played_in_game_string;
      const val = [dataString];

      // Prepare file for download
      const headerString = "MAX.PREP \n";
      const fileContent = `${headerString}${val}`;
      const blob = new Blob([fileContent], {
        type: "text/plain;charset=utf-8",
      });

      // Create a link and trigger the download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${data.teamA.teamName}-maxPrep(${dateX})-(${data.teamB.teamName}).txt`;
      a.click();
      window.URL.revokeObjectURL(url); // Clean up
    }
  };

  const handleActivityLogDownload = async () => {
    await downloadActivityLog();
    toggleFileDownload(false);
    // toggleSuccessDownload();
  };

  const handleMaxPrepDownload = async () => {
    await downloadMaxPrepTxt();
    toggleFileDownload(false);
    // toggleSuccessDownload();
  };

  const handlePDFdownloadTeamSummary = async () => {
    const dateX = moment(data.createdAt)
      .format("MM-D-YYYY, h:mm:ss a")
      .slice(0, 10);
    try {
      const input = document.getElementById("team-summary");
      if (!input) {
        console.error("Element with ID 'team-summary' not found");
        return;
      }

      const dataUrl = await domtoimage.toPng(input);

      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (input.offsetHeight * imgWidth) / input.offsetWidth;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= 297;
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= 297;
      }

      pdf.save(
        `${data.teamA.teamName}-gameSummary-${dateX}-${data.teamB.teamName}.pdf`
      );
    } catch (error) {
      console.error("Error generating PDF", error);
    }
  };

  const handlePDFdownloadPlayerSummary = async () => {
    const dateX = moment(data.createdAt)
      .format("MM-D-YYYY, h:mm:ss a")
      .slice(0, 10);
    try {
      const input = document.getElementById("player-summary");
      if (!input) {
        console.error("Element with ID 'player-summary' not found");
        return;
      }

      const dataUrl = await domtoimage.toPng(input);

      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (input.offsetHeight * imgWidth) / input.offsetWidth;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= 297;
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= 297;
      }

      pdf.save(
        `${data.teamA.teamName}-player Summary-${dateX}-${data.teamB.teamName}.pdf`
      );
    } catch (error) {
      console.error("Error generating PDF", error);
    }
  };

  const handlePDFdownloadPlayerSummaryCombined = async () => {
    const dateX = moment(data.createdAt)
      .format("MM-D-YYYY, h:mm:ss a")
      .slice(0, 10);
    try {
      const input = document.getElementById("player-summary-combined");
      if (!input) {
        console.error("Element with ID 'player-summary' not found");
        return;
      }

      const dataUrl = await domtoimage.toPng(input);

      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (input.offsetHeight * imgWidth) / input.offsetWidth;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= 297;
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= 297;
      }

      pdf.save(
        `${data.teamA.teamName}-player Summary Combined-${dateX}-${data.teamB.teamName}.pdf`
      );
    } catch (error) {
      console.error("Error generating PDF", error);
    }
  };

  const handleDownloadForPlayer = () => {
    handlePDFdownloadPlayerSummary(); // First function
    handlePDFdownloadPlayerSummaryCombined(); // Second function
  };

  const toggleGameLogView = () => {
    setGameLogVisible(true); // Open Game Log
    setGameSummaryVisible(false); // Close Game Summary
    setPlayerSummaryVisible(false); // Close Player Summary
  };

  const toggleGameSummaryView = () => {
    setGameLogVisible(false); // Close Game Log
    setGameSummaryVisible(true); // Open Game Summary
    setPlayerSummaryVisible(false); // Close Player Summary
  };

  const togglePlayerSummaryView = () => {
    setGameLogVisible(false); // Close Game Log
    setGameSummaryVisible(false); // Close Game Summary
    setPlayerSummaryVisible(true); // Open Player Summary
  };

  const groupByUuid = (activityState) => {
    return activityState.reduce((acc, curr) => {
      (acc[curr.uuid] = acc[curr.uuid] || []).push(curr);
      return acc;
    }, {});
  };

  const groupedActivities = useMemo(
    () => groupByUuid(activityState),
    [activityState]
  );

  const getOrdinal = (period) => {
    const n = Number(period);
    if (n > 4) return "OT";
    if (!n) return period;
    const j = n % 10;
    const k = n % 100;
    if (j === 1 && k !== 11) return `${n}st`;
    if (j === 2 && k !== 12) return `${n}nd`;
    if (j === 3 && k !== 13) return `${n}rd`;
    return `${n}th`;
  };

  useEffect(() => {
    setActivityState(data?.activityLog || []);
  }, [data?.activityLog]);

  useEffect(() => {
    setPlayedIngameFilteredPlayers(
      data?.teamA.playedInGame.filter((player, index, arr) => {
        return (
          arr.findIndex((p) => p.jersey === player.jersey) ===
          arr.lastIndexOf(player)
        );
      })
    );
  }, [data]);

  const goBack = () => {
    history.goBack();
  };


  const formatPlayerDisplayName = (name) => {
    if (!name) return "";

    const cleaned = name.replace(/\s+/g, " ").trim();
    const parts = cleaned.split(" ");

    // Single word (fallback)
    if (parts.length === 1) {
      return parts[0];
    }

    const firstName = parts[0];
    const lastName = parts[parts.length - 1];

    return `${lastName}, ${firstName.charAt(0)}`;
  };


  const aggregatePlayerStats = async () => {
    try {
      setSeasonStatsLoading(true);

      // ❗ data already contains the SINGLE game (from getOneLog)
      const game = data;
      if (!game) return;

      const playerStatsMap = {};
      // const penaltiesMap = {};
      const teamId = operatorTeam?.teamId._id;

      let totalOpponentShotOG = 0;

      // Extract stats from utility
      const { teamAplayerStats, teamBplayerStats } = GeneratePlayerStats(game);

      // Determine which is our team
      const ourTeamStats =
        game.teamA.teamId === teamId ? teamAplayerStats :
          game.teamB.teamId === teamId ? teamBplayerStats : [];

      const opponentTeamStats =
        game.teamA.teamId === teamId ? teamBplayerStats :
          game.teamB.teamId === teamId ? teamAplayerStats : [];

      // Opponent Shot On Goal tally (single game)
      opponentTeamStats.forEach(p => {
        totalOpponentShotOG += p.shotOG || 0;
      });

      // Aggregate stats for OUR TEAM from SINGLE game
      ourTeamStats.forEach(player => {
        if (!player.player || !player.jersey) return;

        const key = `${player.player}-${player.jersey}`;

        if (!playerStatsMap[key]) {
          playerStatsMap[key] = {
            name: player.player,
            jersey: player.jersey,
            gamesPlayed: 0,
            goals: 0,
            assists: 0,
            shotAttempts: 0,
            shotOG: 0,
            groundBall: 0,
            causedTurnover: 0,
            turnOver: 0,
            takeAway: 0,
            interceptions: 0,
            unforcedErrors: 0,
            foffsAttempts: 0,
            faceoffsWon: 0,
            faceoffsViolation: 0,
            faceoffGB: 0,
            goaliePlayedTime: 0,
            saves: 0,
            shotsConceded: 0,
            shotsOnNet: 0,
            goalsAgainst: 0,
            won: 0,
            lost: 0,
            tie: 0,
            clears: 0,
            clearsSuccessfull: 0,
            clearFailed: 0,
            savesControlled: 0,
            savesNotControlled: 0,
            shotOnGoal: 0
          };
        }

        const stats = playerStatsMap[key];

        stats.gamesPlayed += 1;

        Object.keys(stats).forEach(stat => {
          if (
            stat !== "name" &&
            stat !== "jersey" &&
            stat !== "gamesPlayed" &&
            player[stat] !== undefined
          ) {
            stats[stat] += player[stat] || 0;
          }
        });
      });


      // ●●● Penalties (single game only)
      (game.activityLog || [])
        .filter(item => item.cat === "Penalty" && item.player && item.pTime)
        .forEach(penalty => {
          console.log("RAW PENALTY:", penalty);

          const key = `${penalty.player}-${penalty.jersey}`;

          if (!penaltiesMap[key]) {
            penaltiesMap[key] = {
              player: penalty.playerName || penalty.player || penalty.name,
              jersey: penalty.jersey,
              team: penalty.team,
              count: 0,
              totalTime: 0,
            };
          }

          penaltiesMap[key].count += 1;

          const timeValue = Number(penalty.time) || 0;
          penaltiesMap[key].totalTime += timeValue;


          penaltiesMap[key].totalTime += timeValue;
        });

      setOpponentShotOGTotal(totalOpponentShotOG);
      setPlayerStats(playerStatsMap);

      calculateTopPerformers(playerStatsMap, totalOpponentShotOG, penaltiesMap);

    } catch (err) {
      console.log("ERROR aggregating single game stats:", err.message);
    } finally {
      setSeasonStatsLoading(false);
    }
  };

  const calculateTopPerformers = (statsMap, opponentShotOGTotal) => {
    const players = Object.values(statsMap);
    const penaltiesArray = Object.values(penaltiesMap);

    // Helper: return top N players with stat > 0
    const topN = (arr, key, n = 3) => {
      return arr
        .filter(p => p[key] > 0)           // remove players with 0 value
        .sort((a, b) => b[key] - a[key])   // sort high → low
        .slice(0, n);
    };

    const topPerformers = {
      // Simple stats (use helper)
      goals: topN(players, "goals"),
      assists: topN(players, "assists"),
      shotOG: topN(players, "shotOG"),
      causedTurnover: topN(players, "causedTurnover"),
      groundBall: topN(players, "groundBall"),
      turnOver: topN(players, "turnOver"),
      shotAttempts: topN(players, "shotAttempts"),

      // Penalties top 3 (by count)
      penalties: penaltiesArray
        .filter(p => p.count > 0)
        .sort((a, b) => b.count - a.count)
        .slice(0, 3),

      // Penalties by time served
      penaltyTime: penaltiesArray
        .filter(p => p.totalTime > 0)
        .sort((a, b) => b.totalTime - a.totalTime)
        .slice(0, 3),

      // Team totals (unchanged)
      teamTotals: {
        penalties: penaltiesArray.reduce((sum, p) => sum + p.count, 0),
        penaltyTime: penaltiesArray.reduce((sum, p) => sum + p.totalTime, 0)
      },

      // Scoring Accuracy (goals / attempts)
      scoringAccuracy: players
        .filter(p => p.shotAttempts > 0)
        .map(p => ({
          ...p,
          scoringAccuracy: p.goals / p.shotAttempts
        }))
        .sort((a, b) => b.scoringAccuracy - a.scoringAccuracy)
        .slice(0, 3),

      // Shooting Accuracy (shotOG / attempts)
      shootingAccuracy: players
        .filter(p => p.shotAttempts > 0)
        .map(p => ({
          ...p,
          shootingAccuracy: p.shotOG / p.shotAttempts
        }))
        .sort((a, b) => b.shootingAccuracy - a.shootingAccuracy)
        .slice(0, 3),

      // Faceoff win % (wins / attempts)
      faceoffWinPct: players
        .filter(p => p.foffsAttempts > 0)
        .map(p => ({
          ...p,
          winPct: p.faceoffsWon / p.foffsAttempts
        }))
        .sort((a, b) => b.winPct - a.winPct)
        .slice(0, 3),

      // Save % (saves / opponent shots on goal)
      saves: players
        .filter(p => p.saves > 0)
        .map(p => ({
          ...p,
          savePct: opponentShotOGTotal > 0 ? (p.saves / opponentShotOGTotal) : 0
        }))
        .sort((a, b) => b.savePct - a.savePct)
        .slice(0, 3),

      // Clears (success / attempts)
      clears: players
        .filter(p => p.clears > 0)
        .map(p => ({
          ...p,
          clearPct: p.clearsSuccessfull / p.clears
        }))
        .sort((a, b) => b.clearPct - a.clearPct)
        .slice(0, 3),

      // Controlled saves
      savesControlled: players
        .filter(p => p.saves > 0 && p.savesControlled > 0)
        .map(p => ({
          ...p,
          controlledPct: p.savesControlled / p.saves
        }))
        .sort((a, b) => b.controlledPct - a.controlledPct)
        .slice(0, 3),

      // Not controlled saves
      savesNotControlled: players
        .filter(p => p.saves > 0 && p.savesNotControlled > 0)
        .map(p => ({
          ...p,
          notControlledPct: p.savesNotControlled / p.saves
        }))
        .sort((a, b) => b.notControlledPct - a.notControlledPct)
        .slice(0, 3)
    };

    setTopPerformers(topPerformers);
  };


  useEffect(() => {
    if (data && operatorTeam?.teamId?._id) {
      aggregatePlayerStats();
    }
  }, [data, operatorTeam?.teamId?._id]);

  const formatMinutesToMMSS = (minutes = 0) => {
    const totalSeconds = Math.floor(minutes * 60);
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;

    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };


  // Convert playerStatsMap to array
  const allPlayers = Object.values(playerStats);
  const penaltiesMap = {};
  // Calculate team totals for specific stats
  const teamTotals = {
    goals: allPlayers.reduce((sum, p) => sum + (p.goals || 0), 0),
    assists: allPlayers.reduce((sum, p) => sum + (p.assists || 0), 0),
    groundBall: allPlayers.reduce((sum, p) => sum + (p.groundBall || 0), 0),
    causedTurnover: allPlayers.reduce((sum, p) => sum + (p.causedTurnover || 0), 0),
    shotOG: allPlayers.reduce((sum, p) => sum + (p.shotOG || 0), 0),
    shotAttempts: allPlayers.reduce((sum, p) => sum + (p.shotAttempts || 0), 0),
    turnOver: allPlayers.reduce((sum, p) => sum + (p.turnOver || 0), 0),
    clears: allPlayers.reduce((sum, p) => sum + (p.clears || 0), 0),
    saves: allPlayers.reduce((sum, p) => sum + (p.saves || 0), 0),
    faceoffsWon: allPlayers.reduce((sum, p) => sum + (p.faceoffsWon || 0), 0),
    foffsAttempts: allPlayers.reduce((sum, p) => sum + (p.foffsAttempts || 0), 0),
  };
  teamTotals.scoringAccuracy = allPlayers.reduce((sum, p) => sum + (p.goals || 0), 0)
    / Math.max(allPlayers.reduce((sum, p) => sum + (p.shotAttempts || 0), 0), 1);
  teamTotals.shootingAccuracy = allPlayers.reduce((sum, p) => sum + (p.shotOG || 0), 0)
    / Math.max(allPlayers.reduce((sum, p) => sum + (p.shotAttempts || 0), 0), 1);
  teamTotals.faceoffWinPct = allPlayers.reduce((sum, p) => sum + (p.faceoffsWon || 0), 0)
    / Math.max(allPlayers.reduce((sum, p) => sum + (p.foffsAttempts || 0), 0), 1);
  teamTotals.savePct = opponentShotOGTotal > 0
    ? (teamTotals.saves / opponentShotOGTotal)
    : 0;

  teamTotals.clearPct = allPlayers.reduce((sum, p) => sum + (p.clearsSuccessfull || 0), 0)
    / Math.max(allPlayers.reduce((sum, p) => sum + (p.clears || 0), 0), 1);
  teamTotals.controlledPct = allPlayers.reduce((sum, p) => sum + (p.savesControlled || 0), 0)
    / Math.max(allPlayers.reduce((sum, p) => sum + (p.saves || 0), 0), 1);
  teamTotals.notControlledPct = allPlayers.reduce((sum, p) => sum + (p.savesNotControlled || 0), 0)
    / Math.max(allPlayers.reduce((sum, p) => sum + (p.saves || 0), 0), 1);

  return (
    <div className="main">
      <UserSidebar />
      {/* <h1 className="mainTitle" style={{ paddingTop: "20px" }}>
        GAME DETAILS
      </h1> */}
      {/* <div className='imageBoxMain'>
        <img src={mainImg} className="headerImage" alt="Dashboard Header" />
      </div> */}

      <div className="headingBoxTop">
        <div className="matchDetails">
          <h2 className="teamNameHeading">{data?.teamA.teamName} </h2>
          <div className="subHead">
            {moment(data?.general?.gameDate)
              .format("MM/DD/YYYY, h:mm:ss a")
              .slice(0, 10)}
            <p
              style={{
                color:
                  data?.teamA.status === "Won"
                    ? "#48dd52ff"
                    : data?.teamA.status === "Lost"
                      ? "#e44444ff"
                      : "#ffffffff",
              }}
            >
              {data?.teamA.status}
            </p>
            {data?.teamA?.goals}-{data?.teamB?.goals}
          </div>

          <p style={{ color: "white", fontWeight: "700" }}>
            {data?.teamA.teamName === data?.general?.homeTeam?.teamName
              ? "VS "
              : "AT "}

            {data?.teamB.teamName} <span
              style={{
                color: "rgb(160, 160, 4)",
                fontWeight: "700",
                marginBottom: "15px",
              }}
            >
              ({data?.general?.conference ? "Conference Game" : "Non-Conference"})
            </span>
          </p>
        </div>
      </div>
      <div />

      <div className="seasonStatsSection" style={{ width: "70%", marginRight: "30px", }}>
        <h2>Season Player/Team Statistics</h2>

        {seasonStatsLoading ? (
          <div className="loading">Loading player statistics...</div>
        ) : Object.keys(playerStats).length > 0 ? (
          <>
            {/* Top Performers */}
            <div className="topPerformers">
              {/* <h3>Top Performers</h3> */}
              <div className="performerCategories">
                {/* Goals */}
                <div className="performerCategory">
                  <h4>Goals</h4>
                  {topPerformers.goals?.length > 0 ? (
                    topPerformers.goals.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {formatPlayerDisplayName(player.name)}</span>
                        <span className="statValue">{player.goals}</span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue">{teamTotals.goals}</span>
                  </div>
                </div>

                {/* Assists */}
                <div className="performerCategory">
                  <h4>Assists</h4>
                  {topPerformers.assists?.length > 0 ? (
                    topPerformers.assists.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {formatPlayerDisplayName(player.name)}</span>
                        <span className="statValue">{player.assists}</span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue">{teamTotals.assists}</span>
                  </div>
                </div>

                {/* Total Shots */}
                <div className="performerCategory">
                  <h4>Total Shots</h4>
                  {topPerformers.shotAttempts?.length > 0 ? (
                    topPerformers.shotAttempts.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {formatPlayerDisplayName(player.name)}</span>
                        <span className="statValue">{player.shotAttempts}</span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue">{teamTotals.shotAttempts}</span>
                  </div>
                </div>

                {/* Scoring Accuracy */}
                <div className="performerCategory">
                  <h4>Scoring Accuracy</h4>
                  <p>(Goals / Total Shots)</p>
                  {topPerformers.scoringAccuracy?.length > 0 ? (
                    topPerformers.scoringAccuracy.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {formatPlayerDisplayName(player.name)}</span>
                        <span className="statValue">
                          {player.shotAttempts > 0
                            ? ((player.goals / player.shotAttempts) * 100).toFixed(1)
                            : '0.0'}%
                        </span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue">
                      {(teamTotals.scoringAccuracy * 100).toFixed(1)}%
                    </span>
                  </div>
                </div>

                {/* Shooting Accuracy */}
                <div className="performerCategory">
                  <h4>Shooting Accuracy</h4>
                  <p>(Shots On Goal / Total Shots)</p>
                  {topPerformers.shootingAccuracy?.length > 0 ? (
                    topPerformers.shootingAccuracy.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {formatPlayerDisplayName(player.name)}</span>
                        <span className="statValue">
                          {(player.shootingAccuracy * 100).toFixed(1)}%
                        </span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue">
                      {(teamTotals.shootingAccuracy * 100).toFixed(1)}%
                    </span>
                  </div>
                </div>

                {/* Ground Balls */}
                <div className="performerCategory">
                  <h4>Ground Balls</h4>
                  {topPerformers.groundBall?.length > 0 ? (
                    topPerformers.groundBall.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {formatPlayerDisplayName(player.name)}</span>
                        <span className="statValue">{player.groundBall}</span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue">{teamTotals.groundBall}</span>
                  </div>
                </div>

                {/* Turnovers Caused */}
                <div className="performerCategory">
                  <h4>Turnovers Caused</h4>
                  {topPerformers.causedTurnover?.length > 0 ? (
                    topPerformers.causedTurnover.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {formatPlayerDisplayName(player.name)}</span>
                        <span className="statValue">{player.causedTurnover}</span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue">{teamTotals.causedTurnover}</span>
                  </div>
                </div>

                {/* Faceoff Win % */}
                <div className="performerCategory">
                  <h4>Faceoffs</h4>
                  <p>(Won / Attempts)</p>
                  {topPerformers.faceoffWinPct?.length > 0 ? (
                    topPerformers.faceoffWinPct.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {formatPlayerDisplayName(player.name)}</span>
                        <span className="statValue">{(player.winPct * 100).toFixed(1)}%</span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue">{(teamTotals.faceoffWinPct * 100).toFixed(1)}%</span>
                  </div>
                </div>

                {/* Turnovers */}
                <div className="performerCategory">
                  <h4>Turnovers</h4>
                  {topPerformers.turnOver?.length > 0 ? (
                    topPerformers.turnOver.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {formatPlayerDisplayName(player.name)}</span>
                        <span className="statValue">{player.turnOver}</span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue">{teamTotals.turnOver}</span>
                  </div>
                </div>

                {/* Clears */}
                <div className="performerCategory">
                  <h4>Clears</h4>
                  <p>(Successful / Attempts)</p>
                  {topPerformers.clears?.length > 0 ? (
                    topPerformers.clears.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {formatPlayerDisplayName(player.name)}</span>
                        <span className="statValue">{(player.clearPct * 100).toFixed(1)}%</span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue">{(teamTotals.clearPct * 100).toFixed(1)}%</span>
                  </div>
                </div>

                {/* Shots On Goal */}
                {/* <div className="performerCategory">
                    <h4>Shots On Goal</h4>
                    {topPerformers.shotOG?.length > 0 ? (
                      topPerformers.shotOG.map((player, index) => (
                        <div key={index} className="performerItem">
                          <span className="playerName">#{player.jersey} {formatPlayerDisplayName(player.name)}</span>
                          <span className="statValue">{player.shotOG}</span>
                        </div>
                      ))
                    ) : (
                      <div className="noData">No data available</div>
                    )}
                    <div className="performerItem teamTotal">
                      <span className="playerName"><strong>Team Total</strong></span>
                      <span className="statValue">{teamTotals.shotOG}</span>
                    </div>
                  </div> */}

                <div className="performerCategory">
                  <h4>Penalties</h4>
                  {topPerformers.penalties?.length > 0 ? (
                    topPerformers.penalties.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {player.player}</span>
                        <span className="statValue">{player.count}</span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue">{topPerformers.teamTotals?.penalties || 0}</span>
                  </div>
                </div>

                <div className="performerCategory">
                  <h4>Penalty Time</h4>
                  {topPerformers.penaltyTime?.length > 0 ? (
                    topPerformers.penaltyTime.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {player.player}</span>
                        <span className="statValue">{formatMinutesToMMSS(player.totalTime)}</span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue"><span className="statValue">{formatMinutesToMMSS(topPerformers.teamTotals?.penaltyTime || 0)}</span></span>
                  </div>
                </div>

                {/* Saves */}
                <div className="performerCategory">
                  <h4>Saves</h4>
                  <p>(Saves / Shots On Goal)</p>
                  {topPerformers.saves?.length > 0 ? (
                    topPerformers.saves.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {formatPlayerDisplayName(player.name)}</span>
                        <span className="statValue">{(player.savePct * 100).toFixed(1)}%</span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue">{(teamTotals.savePct * 100).toFixed(1)}%</span>
                  </div>
                </div>

                {/* Saves Controlled */}
                <div className="performerCategory">
                  <h4>Saves Controlled</h4>
                  <p>(Controlled / Saves)</p>
                  {topPerformers.savesControlled?.length > 0 ? (
                    topPerformers.savesControlled.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {formatPlayerDisplayName(player.name)}</span>
                        <span className="statValue">{(player.controlledPct * 100).toFixed(1)}%</span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue">{(teamTotals.controlledPct * 100).toFixed(1)}%</span>
                  </div>
                </div>

                {/* Saves Not-Controlled */}
                <div className="performerCategory">
                  <h4>Saves Not-Controlled</h4>
                  <p>(Not Controlled / Saves)</p>
                  {topPerformers.savesNotControlled?.length > 0 ? (
                    topPerformers.savesNotControlled.map((player, index) => (
                      <div key={index} className="performerItem">
                        <span className="playerName">#{player.jersey} {formatPlayerDisplayName(player.name)}</span>
                        <span className="statValue">{(player.notControlledPct * 100).toFixed(1)}%</span>
                      </div>
                    ))
                  ) : (
                    <div className="noData">No data available</div>
                  )}
                  <div className="performerItem teamTotal">
                    <span className="playerName"><strong>Team Total</strong></span>
                    <span className="statValue">{(teamTotals.notControlledPct * 100).toFixed(1)}%</span>
                  </div>
                </div>
              </div>

            </div>
          </>
        ) : (
          <div className="noData">No player statistics available</div>
        )}
      </div>

      <div className="headingBox">
        <div className="details">
          <div
            className="allBtnsContainer"
            style={{ display: "flex", margin: "15px 0" }}
          >
            <div className="gameDetailsRow">
              <span className="txt">Game Log</span>
              <button className="dwnldBtn" onClick={handleActivityLogDownload}>
                <p className="btnRTxtGameDetails"><DownloadIcon style={{ color: "#c20101", fontSize: 20 }} />
                </p>
              </button>
              <button className="dwnldBtn" onClick={toggleGameLogView}>
                <p className="btnRTxtGameDetails"><VisibilityIcon style={{ color: "#c20101", fontSize: 20 }} />
                </p>
              </button>
            </div>

            <div className="gameDetailsRow">
              <span className="txt">Game Summary</span>
              <button
                className="dwnldBtn"
                onClick={handlePDFdownloadTeamSummary}
              >
                <p className="btnRTxtGameDetails"><DownloadIcon style={{ color: "#c20101", fontSize: 20 }} />
                </p>
              </button>
              <button className="dwnldBtn" onClick={toggleGameSummaryView}>
                <p className="btnRTxtGameDetails"><VisibilityIcon style={{ color: "#c20101", fontSize: 20 }} />
                </p>
              </button>
            </div>

            <div className="gameDetailsRow">
              <span className="txt">Player Summary</span>
              <button className="dwnldBtn" onClick={handleDownloadForPlayer}>
                <p className="btnRTxtGameDetails"><DownloadIcon style={{ color: "#c20101", fontSize: 20 }} />
                </p>
              </button>
              <button className="dwnldBtn" onClick={togglePlayerSummaryView}>
                <p className="btnRTxtGameDetails"><VisibilityIcon style={{ color: "#c20101", fontSize: 20 }} />
                </p>
              </button>
            </div>
            <div className="gameDetailsRow">
              <span className="txt">MaxPrep Data</span>
              {data?.general?.playersStatsA === true ? (
                <button className="dwnldBtn" onClick={handleMaxPrepDownload}>
                  <p className="btnRTxtGameDetails"><DownloadIcon style={{ color: "#c20101", fontSize: 20 }} />
                  </p>
                </button>
              ) : (
                <DownloadIcon style={{ color: "grey", fontSize: 20 }} />
              )}
            </div>
          </div>
          {gameLogVisible && (
            <>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: '20px' }}>
                <p
                  style={{
                    color: "black",
                    fontWeight: "700",
                    margin: "15px 0 15px 0",
                    fontSize: "34px",
                  }}
                >
                  Game Log
                </p>
                <button
                  onClick={() => setGameLogVisible(false)}
                  style={{
                    position: "relative",
                    background: "none",
                    border: "2px solid red",
                    borderRadius: "10px",
                    fontSize: "24px",
                    cursor: "pointer",
                    color: "red",
                    fontWeight: '700',
                    marginLeft: '20px'
                  }}
                >
                  X
                </button>
              </div>
              <div nestedScrollEnabled={true} style={{ margin: "5px 15px" }}>
                {Object.keys(groupedActivities).map((uuid, index) => (
                  <div key={uuid}>
                    {groupedActivities[uuid].map((activity, idx) => (
                      <div className="row" key={idx}>
                        <p className="activityTxtTeam">
                          {activity?.team ? `${activity.team} -` : ""}
                        </p>
                        <p className="activityTxtPeriod">
                          {activity?.period
                            ? `${getOrdinal(activity.period)} -`
                            : ""}
                        </p>
                        <p className="activityTxtTime">
                          {activity?.clockTime
                            ? ` ${activity.clockTime} -`
                            : ""}
                        </p>
                        <p
                          style={{ color: "red" }}
                          className="ActivityTxtStatement"
                        >
                          {activity?.statement && ` ${activity.statement}`}
                          {activity?.addDesc && ` - ${activity.addDesc}`}
                          {activity?.goaliePlayedTime ? ` - Goalie Time played: ${activity.goaliePlayedTime}` : ""}
                        </p>
                        <p className="activityTxtPlayer">
                          {activity?.jersey !== "-1" &&
                            activity?.jersey &&
                            `  #${activity.jersey}`}

                          {activity?.jersey !== "-1" &&
                            activity?.player &&
                            ` ${activity.player}`}
                        </p>
                        <p
                          style={{ color: "red" }}
                          className="ActivityTxtOther"
                        >
                          {activity?.otherTxt ? ` ${activity.otherTxt}` : ""}
                        </p>
                      </div>
                    ))}

                    {index < Object.keys(groupedActivities).length - 1 && (
                      <div className="divider" />
                    )}
                  </div>
                ))}

                {playedIngameFilteredPlayers?.map((val, index) => (
                  <p key={index} className="activityTxt">
                    {data?.teamA.teamName} -{" "}
                    <p style={{ color: "red" }}>Played In Game</p> - #
                    {val.jersey} {val.playerName}
                  </p>
                ))}
              </div>
            </>
          )}
          {gameSummaryVisible && (
            <div
              id="team-summary"
              style={{ padding: "20px", backgroundColor: "white", width: "90%" }}
            >
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: '20px' }}>
                <p
                  style={{
                    color: "black",
                    fontWeight: "700",
                    margin: "15px 0 15px 0",
                    fontSize: "34px",
                  }}
                >
                  Game Summary
                </p>
                <button
                  onClick={() => setGameSummaryVisible(false)}
                  style={{
                    position: "relative",
                    background: "none",
                    border: "2px solid red",
                    borderRadius: "10px",
                    fontSize: "24px",
                    cursor: "pointer",
                    color: "red",
                    fontWeight: '700',
                    marginLeft: '20px'
                  }}
                >
                  X
                </button>
              </div>
              <p className="team-heading">
                {data.teamA.teamName}{" "}
                <span style={{ color: "#a8a845" }}> Vs </span>{" "}
                {data.teamB.teamName}
              </p>
              <div className="subHeadSummary">
                {moment(data?.general?.gameDate)
                  .format("MM/DD/YYYY, h:mm:ss a")
                  .slice(0, 10)}
                <p
                  style={{
                    color:
                      data?.teamA.status === "Won"
                        ? "#035909"
                        : data?.teamA.status === "Lost"
                          ? "#7c0303"
                          : "#0a2e5e",
                  }}
                >
                  {data?.teamA.status}
                </p>
                {data?.teamA?.goals}-{data?.teamB?.goals}
              </div>

              <div className="row-div-main-stat">
                <p className="team-sub-head" style={{ color: "#fff" }}>
                  SCORING
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  1st
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  2nd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  3rd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  4th
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  Total
                </p>
              </div>

              {/* <div className="stat-row-div">
                <p className="stat-heading">Goals</p>
              </div> */}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Shot Attempts
                </p>
                <p className="qtr-stat-box-grey">{A1?.shotAttempts ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.shotAttempts ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.shotAttempts ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.shotAttempts ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.shotAttempts ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.shotAttempts ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.shotAttempts ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.shotAttempts ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.shotAttempts ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.shotAttempts ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Shot On Goal</p>
                <p className="qtr-stat-box">{A1?.shotOnGoal ?? 0}</p>
                <p className="qtr-stat-box">{A2?.shotOnGoal ?? 0}</p>
                <p className="qtr-stat-box">{A3?.shotOnGoal ?? 0}</p>
                <p className="qtr-stat-box">{A4?.shotOnGoal ?? 0}</p>
                <p className="qtr-stat-box">{A?.shotOnGoal ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.shotOnGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.shotOnGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.shotOnGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.shotOnGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.shotOnGoal ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Shot Lost Possession
                </p>
                <p className="qtr-stat-box-grey">{A1?.shotLostPoss ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.shotLostPoss ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.shotLostPoss ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.shotLostPoss ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.shotLostPoss ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.shotLostPoss ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.shotLostPoss ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.shotLostPoss ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.shotLostPoss ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.shotLostPoss ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Shot Kept Possession</p>
                <p className="qtr-stat-box">{A1?.shotKeptPoss ?? 0}</p>
                <p className="qtr-stat-box">{A2?.shotKeptPoss ?? 0}</p>
                <p className="qtr-stat-box">{A3?.shotKeptPoss ?? 0}</p>
                <p className="qtr-stat-box">{A4?.shotKeptPoss ?? 0}</p>
                <p className="qtr-stat-box">{A?.shotKeptPoss ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.shotKeptPoss ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.shotKeptPoss ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.shotKeptPoss ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.shotKeptPoss ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.shotKeptPoss ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Goals
                </p>
                <p className="qtr-stat-box-grey">{A1?.goals ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.goals ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.goals ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.goals ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.goals ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.goals ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.goals ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.goals ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.goals ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.goals ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Assists</p>
                <p className="qtr-stat-box">{A1?.assists ?? 0}</p>
                <p className="qtr-stat-box">{A2?.assists ?? 0}</p>
                <p className="qtr-stat-box">{A3?.assists ?? 0}</p>
                <p className="qtr-stat-box">{A4?.assists ?? 0}</p>
                <p className="qtr-stat-box">{A?.assists ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.assists ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.assists ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.assists ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.assists ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.assists ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Man-up Opp
                </p>
                <p className="qtr-stat-box-grey">{A1?.manUpOpp ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.manUpOpp ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.manUpOpp ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.manUpOpp ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.manUpOpp ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.manUpOpp ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.manUpOpp ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.manUpOpp ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.manUpOpp ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.manUpOpp ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Man-up Goal</p>
                <p className="qtr-stat-box">{A1?.manUpGoal ?? 0}</p>
                <p className="qtr-stat-box">{A2?.manUpGoal ?? 0}</p>
                <p className="qtr-stat-box">{A3?.manUpGoal ?? 0}</p>
                <p className="qtr-stat-box">{A4?.manUpGoal ?? 0}</p>
                <p className="qtr-stat-box">{A?.manUpGoal ?? 0}</p>
              </div>

              {data?.general?.noneStatsB ? (
                <div>
                  <p>&nbsp;</p>
                </div>
              ) : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.manUpGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp"> {B2?.manUpGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.manUpGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.manUpGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.manUpGoal ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div-main-stat">
                <p className="team-sub-head" style={{ color: "#fff" }}>
                  FIELDING
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  1st
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  2nd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  3rd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  4th
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  Total
                </p>
              </div>

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Ground Ball
                </p>
                <p className="qtr-stat-box-grey">{A1?.groundBall ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.groundBall ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.groundBall ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.groundBall ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.groundBall ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.groundBall ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.groundBall ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.groundBall ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.groundBall ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.groundBall ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Caused Turnover</p>
                <p className="qtr-stat-box">{A1?.causedTurnover ?? 0}</p>
                <p className="qtr-stat-box">{A2?.causedTurnover ?? 0}</p>
                <p className="qtr-stat-box">{A3?.causedTurnover ?? 0}</p>
                <p className="qtr-stat-box">{A4?.causedTurnover ?? 0}</p>
                <p className="qtr-stat-box">{A?.causedTurnover ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">
                      {B1?.causedTurnover ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">
                      {B2?.causedTurnover ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">
                      {B3?.causedTurnover ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">
                      {B4?.causedTurnover ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">{B?.causedTurnover ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Takeaway
                </p>
                <p className="qtr-stat-box-grey">{A1?.takeAway ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.takeAway ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.takeAway ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.takeAway ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.takeAway ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.takeAway ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.takeAway ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.takeAway ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.takeAway ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.takeAway ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Interception</p>
                <p className="qtr-stat-box">{A1?.interceptions ?? 0}</p>
                <p className="qtr-stat-box">{A2?.interceptions ?? 0}</p>
                <p className="qtr-stat-box">{A3?.interceptions ?? 0}</p>
                <p className="qtr-stat-box">{A4?.interceptions ?? 0}</p>
                <p className="qtr-stat-box">{A?.interceptions ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.interceptions ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.interceptions ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.interceptions ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.interceptions ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.interceptions ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Blocked Shot
                </p>
                <p className="qtr-stat-box-grey">{A1?.blockedShot ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.blockedShot ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.blockedShot ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.blockedShot ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.blockedShot ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.blockedShot ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.blockedShot ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.blockedShot ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.blockedShot ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.blockedShot ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Turnovers</p>
                <p className="qtr-stat-box">{A1?.turnOver ?? 0}</p>
                <p className="qtr-stat-box">{A2?.turnOver ?? 0}</p>
                <p className="qtr-stat-box">{A3?.turnOver ?? 0}</p>
                <p className="qtr-stat-box">{A4?.turnOver ?? 0}</p>
                <p className="qtr-stat-box">{A?.turnOver ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.turnOver ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.turnOver ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.turnOver ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.turnOver ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.turnOver ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Unforced Error
                </p>
                <p className="qtr-stat-box-grey">{A1?.unforcedError ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.unforcedError ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.unforcedError ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.unforcedError ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.unforcedError ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B1?.unforcedError ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B2?.unforcedError ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B3?.unforcedError ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B4?.unforcedError ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">{B?.unforcedError ?? 0}</p>
                  </div>
                </>
              )}

              {/* <div className="row-div">
                <p className="team-stat-box">Clears</p>
                <p className="qtr-stat-box">{A1?.clears ?? 0}</p>
                <p className="qtr-stat-box">{A2?.clears ?? 0}</p>
                <p className="qtr-stat-box">{A3?.clears ?? 0}</p>
                <p className="qtr-stat-box">{A4?.clears ?? 0}</p>
                <p className="qtr-stat-box">{A?.clears ?? 0}</p>
              </div>
              <div className="row-div">
                <p className="team-stat-box-opp">&nbsp;</p>
                <p className="qtr-stat-box-opp">{B1?.clears ?? 0}</p>
                <p className="qtr-stat-box-opp">{B2?.clears ?? 0}</p>
                <p className="qtr-stat-box-opp">{B3?.clears ?? 0}</p>
                <p className="qtr-stat-box-opp">{B4?.clears ?? 0}</p>
                <p className="qtr-stat-box-opp">{B?.clears ?? 0}</p>
              </div> */}

              <div className="row-div">
                <p className="team-stat-box">Clear Attempt</p>
                <p className="qtr-stat-box">{A1?.clearAttempt ?? 0}</p>
                <p className="qtr-stat-box">{A2?.clearAttempt ?? 0}</p>
                <p className="qtr-stat-box">{A3?.clearAttempt ?? 0}</p>
                <p className="qtr-stat-box">{A4?.clearAttempt ?? 0}</p>
                <p className="qtr-stat-box">{A?.clearAttempt ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.clearAttempt ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.clearAttempt ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.clearAttempt ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.clearAttempt ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.clearAttempt ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Clear Successful
                </p>
                <p className="qtr-stat-box-grey">{A1?.clearSuccess ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.clearSuccess ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.clearSuccess ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.clearSuccess ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.clearSuccess ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.clearSuccess ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.clearSuccess ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.clearSuccess ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.clearSuccess ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.clearSuccess ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Clear Failed</p>
                <p className="qtr-stat-box">{A1?.clearFailed ?? 0}</p>
                <p className="qtr-stat-box">{A2?.clearFailed ?? 0}</p>
                <p className="qtr-stat-box">{A3?.clearFailed ?? 0}</p>
                <p className="qtr-stat-box">{A4?.clearFailed ?? 0}</p>
                <p className="qtr-stat-box">{A?.clearFailed ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.clearFailed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.clearFailed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.clearFailed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.clearFailed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.clearFailed ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div-main-stat">
                <p className="team-sub-head" style={{ color: "#fff" }}>
                  FACEOFF
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  1st
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  2nd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  3rd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  4th
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  Total
                </p>
              </div>

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Faceoff Attempt
                </p>
                <p
                  className="qtr-stat-box-grey"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  {A1?.faceoffsAttempts ?? 0}
                </p>
                <p className="qtr-stat-box-grey">{A2?.faceoffsAttempts ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.faceoffsAttempts ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.faceoffsAttempts ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.faceoffsAttempts ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B1?.faceoffsAttempts ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B2?.faceoffsAttempts ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B3?.faceoffsAttempts ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B4?.faceoffsAttempts ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B?.faceoffsAttempts ?? 0}
                    </p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Draw Control</p>
                <p className="qtr-stat-box">{A1?.drawControl ?? 0}</p>
                <p className="qtr-stat-box">{A2?.drawControl ?? 0}</p>
                <p className="qtr-stat-box">{A3?.drawControl ?? 0}</p>
                <p className="qtr-stat-box">{A4?.drawControl ?? 0}</p>
                <p className="qtr-stat-box">{A?.drawControl ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.drawControl ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.drawControl ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.drawControl ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.drawControl ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.drawControl ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Faceoff Won
                </p>
                <p className="qtr-stat-box-grey">{A1?.faceoffsWon ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.faceoffsWon ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.faceoffsWon ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.faceoffsWon ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.faceoffsWon ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.faceoffsWon ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.faceoffsWon ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.faceoffsWon ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.faceoffsWon ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.faceoffsWon ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Draw Lost</p>
                <p className="qtr-stat-box">{A1?.drawLost ?? 0}</p>
                <p className="qtr-stat-box">{A2?.drawLost ?? 0}</p>
                <p className="qtr-stat-box">{A3?.drawLost ?? 0}</p>
                <p className="qtr-stat-box">{A4?.drawLost ?? 0}</p>
                <p className="qtr-stat-box">{A?.drawLost ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.drawLost ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.drawLost ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.drawLost ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.drawLost ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.drawLost ?? 0}</p>
                  </div>
                </>
              )}
              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Faceoff Lost
                </p>
                <p className="qtr-stat-box-grey">{A1?.faceoffLost ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.faceoffLost ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.faceoffLost ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.faceoffLost ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.faceoffLost ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.faceoffLost ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.faceoffLost ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.faceoffLost ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.faceoffLost ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.faceoffLost ?? 0}</p>
                  </div>
                </>
              )}
              <div className="row-div">
                <p className="team-stat-box">F/O Ground Ball</p>
                <p className="qtr-stat-box">{A1?.faceoffGB ?? 0}</p>
                <p className="qtr-stat-box">{A2?.faceoffGB ?? 0}</p>
                <p className="qtr-stat-box">{A3?.faceoffGB ?? 0}</p>
                <p className="qtr-stat-box">{A4?.faceoffGB ?? 0}</p>
                <p className="qtr-stat-box">{A?.faceoffGB ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.faceoffGB ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.faceoffGB ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.faceoffGB ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.faceoffGB ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.faceoffGB ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Faceoff Violation
                </p>
                <p className="qtr-stat-box-grey">
                  {A1?.faceoffViolations ?? 0}
                </p>
                <p className="qtr-stat-box-grey">
                  {A2?.faceoffViolations ?? 0}
                </p>
                <p className="qtr-stat-box-grey">
                  {A3?.faceoffViolations ?? 0}
                </p>
                <p className="qtr-stat-box-grey">
                  {A4?.faceoffViolations ?? 0}
                </p>
                <p className="qtr-stat-box-grey">{A?.faceoffViolations ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{
                        backgroundColor: "rgb(212, 211, 211)",
                      }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B1?.faceoffViolations ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B2?.faceoffViolations ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B3?.faceoffViolations ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B4?.faceoffViolations ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B?.faceoffViolations ?? 0}
                    </p>
                  </div>
                </>
              )}

              <div className="row-div-main-stat">
                <p className="team-sub-head" style={{ color: "#fff" }}>
                  GOAL TENDING
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  1st
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  2nd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  3rd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  4th
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  Total
                </p>
              </div>

              {/* <div className="row-div">
                <p className="team-stat-box">SOG/SAVES</p>
                <p className="qtr-stat-box">
                {A1?.shotOG ?? 0}/{A1?.saves ?? 0}{" "} 
                {A1?.shotOG > 0 ? ((A1?.saves ?? 0) / (A1?.shotOG) * 100).toFixed(1) : '0.0'}%
                </p>
                <p className="qtr-stat-box">
                {A2?.shotOG ?? 0}/{A2?.saves ?? 0}{" "} 
                {A2?.shotOG > 0 ? ((A2?.saves ?? 0) / (A2?.shotOG) * 100).toFixed(1) : '0.0'}%
                </p>
                <p className="qtr-stat-box">
                {A3?.shotOG ?? 0}/{A3?.saves ?? 0}{" "} 
                {A3?.shotOG > 0 ? ((A3?.saves ?? 0) / (A3?.shotOG) * 100).toFixed(1) : '0.0'}%
                </p>
                <p className="qtr-stat-box">
                {A4?.shotOG ?? 0}/{A4?.saves ?? 0}{" "} 
                {A4?.shotOG > 0 ? ((A4?.saves ?? 0) / (A4?.shotOG) * 100).toFixed(1) : '0.0'}%
                </p>
                <p className="qtr-stat-box">
                {A?.shotOG ?? 0}/{A?.saves ?? 0}{" "}
                {A?.shotOG > 0 ? ((A?.saves ?? 0) / (A?.shotOG) * 100).toFixed(1) : '0.0'}%
                </p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">
                    {B1?.shotOG ?? 0}/{B1?.saves ?? 0}{" "} 
                    {B1?.shotOG > 0 ? ((B1?.saves ?? 0) / (B1?.shotOG) * 100).toFixed(1) : '0.0'}%
                    </p>
                    <p className="qtr-stat-box-opp">
                    {B2?.shotOG ?? 0}/{B2?.saves ?? 0}{" "} 
                    {B2?.shotOG > 0 ? ((B2?.saves ?? 0) / (B2?.shotOG) * 100).toFixed(1) : '0.0'}%
                    </p>
                    <p className="qtr-stat-box-opp">
                    {B3?.shotOG ?? 0}/{B3?.saves ?? 0}{" "} 
                    {B3?.shotOG > 0 ? ((B3?.saves ?? 0) / (B3?.shotOG) * 100).toFixed(1) : '0.0'}%
                    </p>
                    <p className="qtr-stat-box-opp">
                    {B4?.shotOG ?? 0}/{B4?.saves ?? 0}{" "} 
                    {B4?.shotOG > 0 ? ((B4?.saves ?? 0) / (B4?.shotOG) * 100).toFixed(1) : '0.0'}%
                    </p>
                    <p className="qtr-stat-box-opp">
                    {B?.shotOG ?? 0}/{B?.saves ?? 0}{" "} 
                    {B?.shotOG > 0 ? ((B?.saves ?? 0) / (B?.shotOG) * 100).toFixed(1) : '0.0'}%
                    </p>
                  </div>
                </>
              )} */}

              <div className="row-div">
                <p className="team-stat-box">SAVES</p>
                <p className="qtr-stat-box">{A1?.saves ?? 0}</p>
                <p className="qtr-stat-box">{A2?.saves ?? 0}</p>
                <p className="qtr-stat-box">{A3?.saves ?? 0}</p>
                <p className="qtr-stat-box">{A4?.saves ?? 0}</p>
                <p className="qtr-stat-box">{A?.saves ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.saves ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.saves ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.saves ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.saves ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.saves ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Save Controlled
                </p>
                <p className="qtr-stat-box-grey">{A1?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.saveControlled ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B1?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B2?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B3?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B4?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B?.saveControlled ?? 0}
                    </p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Save Controlled</p>
                <p className="qtr-stat-box">{A1?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box">{A2?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box">{A3?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box">{A4?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box">{A?.saveControlled ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">
                      {B1?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">
                      {B2?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">
                      {B3?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">
                      {B4?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">{B?.saveControlled ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Save Not Controlled
                </p>
                <p className="qtr-stat-box-grey">
                  {A1?.saveNotControlled ?? 0}
                </p>
                <p className="qtr-stat-box-grey">
                  {A2?.saveNotControlled ?? 0}
                </p>
                <p className="qtr-stat-box-grey">
                  {A3?.saveNotControlled ?? 0}
                </p>
                <p className="qtr-stat-box-grey">
                  {A4?.saveNotControlled ?? 0}
                </p>
                <p className="qtr-stat-box-grey">{A?.saveNotControlled ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B1?.saveNotControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B2?.saveNotControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B3?.saveNotControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B4?.saveNotControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B?.saveNotControlled ?? 0}
                    </p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Goal Allowed</p>
                <p className="qtr-stat-box">{A1?.goalAllowed ?? 0}</p>
                <p className="qtr-stat-box">{A2?.goalAllowed ?? 0}</p>
                <p className="qtr-stat-box">{A3?.goalAllowed ?? 0}</p>
                <p className="qtr-stat-box">{A4?.goalAllowed ?? 0}</p>
                <p className="qtr-stat-box">{A?.goalAllowed ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.goalAllowed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.goalAllowed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.goalAllowed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.goalAllowed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.goalAllowed ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div-main-stat">
                <p className="team-sub-head" style={{ color: "#fff" }}>
                  PENALTIES
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  1st
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  2nd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  3rd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  4th
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  Total
                </p>
              </div>
            </div>
          )}

          {playerSummaryVisible && (
            <div
              id="player-summary"
              style={{ padding: "20px", backgroundColor: "white", width: "90%" }}
            >
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: '20px' }}>
                <p
                  style={{
                    color: "red",
                    fontWeight: "700",
                    margin: "15px 0",
                    fontSize: "34px",
                  }}
                >
                  Player Summary
                </p>
                <button
                  onClick={() => setPlayerSummaryVisible(false)}
                  style={{
                    position: "relative",
                    background: "none",
                    border: "2px solid red",
                    borderRadius: "10px",
                    fontSize: "24px",
                    cursor: "pointer",
                    color: "red",
                    fontWeight: '700',
                    marginLeft: '20px'
                  }}
                >
                  X
                </button>
              </div>
              <p className="team-heading">
                {data.teamA.teamName}{" "}
                <span style={{ color: "#a8a845" }}>Vs</span>{" "}
                {data.teamB.teamName}
              </p>
              <div className="subHeadSummary">
                {moment(data?.general?.gameDate)
                  .format("MM/DD/YYYY, h:mm:ss a")
                  .slice(0, 10)}
                <p
                  style={{
                    color:
                      data?.teamA.status === "Won"
                        ? "#035909"
                        : data?.teamA.status === "Lost"
                          ? "#7c0303"
                          : "#0a2e5e",
                  }}
                >
                  {data?.teamA.status}
                </p>
                {data?.teamA?.goals}-{data?.teamB?.goals}
              </div>

              {/* Team A Section Tables */}
              {/* <h2>Team A Player Stats</h2> */}
              {Object.keys(sections).map((section) => (
                <div key={section}>
                  <h1 className="sectionHeading">{section}</h1>
                  {renderTable(teamAplayerStats, section, sections[section])}
                </div>
              ))}
            </div>
          )}

          {playerSummaryVisible && (
            <div
              id="player-summary-combined"
              style={{ padding: "20px", backgroundColor: "white", width: "90%" }}
            >
              <p
                style={{
                  color: "red",
                  fontWeight: "700",
                  margin: "15px 0",
                  fontSize: "34px",
                }}
              >
                PLAYER SUMMARY COMBINED STATS
              </p>
              <p className="team-heading">
                {data.teamA.teamName}{" "}
                <span style={{ color: "#a8a845" }}>Vs</span>{" "}
                {data.teamB.teamName}
              </p>
              <div className="subHeadSummary">
                {moment(data?.general?.gameDate)
                  .format("MM/DD/YYYY, h:mm:ss a")
                  .slice(0, 10)}
                <p
                  style={{
                    color:
                      data?.teamA.status === "Won"
                        ? "#035909"
                        : data?.teamA.status === "Lost"
                          ? "#7c0303"
                          : "#0a2e5e",
                  }}
                >
                  {data?.teamA.status}
                </p>
                {data?.teamA?.goals}-{data?.teamB?.goals}
              </div>

              {/* Flex container for sections */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  margin: "0",
                  padding: "0",
                }}
              >
                <div style={{ flex: "1 0 25%", margin: "0", padding: "0" }}>
                  {/* <h1 className="sectionHeading" style={{ margin: '0' }}>{section}</h1> */}
                  {renderTableWithTotals(teamAplayerStats)}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* {delIsVisible && (
        <DeleteOverlay
          isVisible={delIsVisible}
          onBackdropPress={() => toggleDelete(false)}
          navigation={props.navigation}
          handleDelete={handleDelete}
          loading={loading}
        />
      )}
      {visible && (
        <SuccessOverlay
          onBackdropPress={() => toggleSuccessDownload(false)}
          isVisible={visible}
          type="File download has started!"
          noTick={true}
        />
      )}
      {delSuccessVisible && (
        <SuccessOverlay
          onBackdropPress={() => toggleDelSuccessModal(false)}
          isVisible={delSuccessVisible}
          type="Game has been deleted successfully!"
          noTick={true}
        />
      )} */}
    </div>
  );
};

export default GameLogDetails;
